"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenerationStatusEnum = void 0;
var GenerationStatusEnum;
(function (GenerationStatusEnum) {
  GenerationStatusEnum[GenerationStatusEnum["non_applicable"] = -1] = "non_applicable";
  GenerationStatusEnum[GenerationStatusEnum["not_started"] = 0] = "not_started";
  GenerationStatusEnum[GenerationStatusEnum["in_progress"] = 50] = "in_progress";
  GenerationStatusEnum[GenerationStatusEnum["done"] = 100] = "done";
  GenerationStatusEnum[GenerationStatusEnum["failed"] = 300] = "failed";
})(GenerationStatusEnum = exports.GenerationStatusEnum || (exports.GenerationStatusEnum = {}));
